const allClaimApprovalTabs = [
  {
    name: "pending",
    label: "Pending",
    link: "pending",
    permissionId: 11,
    component: null,
    data: "currentRequest",
  },
  {
    name: "upcoming",
    label: "Upcoming",
    link: "upcoming",
    permissionId: 11,
    component: null,
    data: "upcomingRequest",
  },
  {
    name: "responded",
    label: "Responded",
    link: "responded",
    permissionId: 11,
    component: null,
    data: "respondedRequest",
  },
  {
    name: "reimbursement",
    label: "Reimbursement",
    link: "reimbursement",
    permissionId: 12,
    component: null,
    data: "reimburseRequest",
  },
];

export default allClaimApprovalTabs;
